

/**
 *  @deprecated
 * @param def
 * @param langs
 */
export function createEmptyLangObject(def = 'Undefined', langs: string[]) {
    return langs.map((value) => ({ lang: value, name: def }));
}


/**
 *  @deprecated
 * @param def
 * @param langs
 */
export function createEmptyLangObject(def = 'Undefined', langs: string[]) {
    return langs.map((value) => ({ lang: value, name: def }));
}
